import { useEffect, useState } from "react";

import { getTableStructure, insertRecord } from "../../services/crudApi";

import { tableConfig } from "../../config/tableConfig";
import DynamicForm from "../../components/DynamicCrud/DynamicForm";
import MasterDataLoader from "./MasterDataLoader";
import { validateRows } from "../../utils/validateRows";
import { validateRowsDataType } from "../../utils/validateRowsDataType";

const CrudPage = ({ tableName }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [dynamicOptions, setDynamicOptions] = useState({});
  const [masterData, setMasterData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingOpt, setLoadingOpt] = useState(false);

  useEffect(() => {
    loadSchema();
  }, [tableName]);
  useEffect(() => {
    const config = tableConfig[tableName];

    const fixedRows = config?.fixedRows;

    if (fixedRows?.field && Array.isArray(fixedRows?.values)) {
      const generatedRows = fixedRows.values.map((value) => ({
        [fixedRows.field]: value,
      }));

      setRows(generatedRows);
      setRowCount(generatedRows.length);
    } else {
      setRows([{}]);
      setRowCount(1);
    }
  }, [tableName]);

  const loadSchema = async () => {
    try {
      setLoading(true);

      const response = await getTableStructure(tableName);

      setColumns(response.columns);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validation = validateRows(rows, config);

    if (!validation.isValid) {
      const message = validation.errors
        .map((err) => `Row ${err.row} → ${err.field} is required`)
        .join("\n");

      alert(message);

      return;
    }
    const updatedRows = validateRowsDataType({ rows, columns });
    try {
      setLoading(true);

      await insertRecord(tableName, updatedRows);

      alert("Record inserted successfully");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const config = tableConfig[tableName] || {};
  return (
    <div className="" style={{ minHeight: "90vh" }}>
      <MasterDataLoader
        tableName={tableName}
        setMasterData={setMasterData}
        setLoadingOpt={setLoadingOpt}
      />
      <div className="card shadow text-center">
        <div className="card-header">
          <h4>{tableName}</h4>
        </div>

        <div className="card-body text-center" style={{}}>
          <form onSubmit={handleSubmit}>
            {!loadingOpt && (
              <DynamicForm
                columns={columns}
                rows={rows}
                setRows={setRows}
                rowCount={rowCount}
                setRowCount={setRowCount}
                masterData={masterData}
                config={config}
              />
            )}
            <div className="row m-3">
              <button className="btn btn-primary" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CrudPage;
